import classes from "./ThirdStep.module.scss"
import body from "../../../index.module.scss"
import ColoredBlock from './../../ColoredBlock/ColoredBlock';
import SectionTitle from "../../Titles/SectionTitle/SectionTitle";
import Cards from './../../Cards/Cards';
const ThirdStep = () => {
   return (
     <section id="Result" className={classes.Result}>
       <div className={body.container}>
          <ColoredBlock number={3} customClass={classes.ColoredBlock} CustomNumClass={classes.CustomNumClass}/>
          <SectionTitle text={<>ПОЛУЧЕННЫЕ<br/>РЕЗУЛЬТАТЫ</>} customClass={classes.Title}/>
          <div className={classes.List}> 
            <Cards
              customClass={classes.Item}
              customTitleClass={classes.CardsTitle}
              number={"01."}
              title={<>Рост количества страниц основного сайта в индексе поисковых систем более чем в 2 раза.</>}
              text={<>Это при условии, что новых страниц на сайте появилось гораздо меньше.</>}
              />
            <Cards
              customClass={classes.Item}
              customTitleClass={classes.CardsTitle}
              number={"02."}
              title={<>ВРост общего трафика группы сайтов в 2 раза.</>}
              text={<>При том, что у большинства дилеров ТОПОЛ-ЭКО поисковый трафик падает из-за взрывного увеличения количества сайтов дилеров в поиске.</>}
              />
            <Cards
              customClass={classes.Item}
              customTitleClass={classes.CardsTitle}
              number={"03."}
              title={<>Рост конверсии сайта более, чем в 2 раза <span className={classes.TextAccent}>c <span>1,96%</span></span> <span className={classes.TextAccent}>До <span>5%</span></span>  в сезон.</>}
              />
            <Cards
              customClass={classes.Item}
              customTitleClass={classes.CardsTitle}
              number={"04."}
              title={<>Рост количества продаж септика за прошедшие годы был настолько большим, что в 2020 году, впервые, были распроданы все SKU, хранившиеся на складах ТОПОЛ-ЭКО.</>}
              />
          </div>
          <div className={classes.Footer}>
            <p className={classes.Description}>
              Здесь стоит заметить, что в период коронавируса рынок септиков значительно вырос. Это дало компании ТОПОЛ-ЭКО дополнительный рост трафика и продаж.
            </p>
          </div>
        </div>
    </section>
   )
}
export default ThirdStep;